<template>
    <div class="detail">
      <div class="box">
        <div class="flex-box special">
          <div class="first">序号</div>
          <div class="second">大使</div>
          <div class="third">会员昵称</div>
          <div class="fourth">消费额</div>
          <div class="fourth">注册时间</div>
        </div>
        <div class="flex-box special" v-for="(item,index) in lists">
          <div class="first">{{index+1}}</div>
          <div class="second">{{item.real_name}}</div>
          <div class="third">{{item.nickname}}</div>
          <div class="fourth">{{item.machine_amount}}</div>
          <div class="fourth">{{item.create_time}}</div>
        </div>
      </div>
      <div class="foot special">
        <div class="tabs" @click="link(1)">
          <div class="tab tab1"></div>
          <div class="txt">首页</div>
        </div>
        <div class="tabs" @click="link(2)">
          <div class="tab tab2"></div>
          <div class="txt">业绩查询</div>
        </div>
      </div>
    </div>
</template>

<script>
  let role
  let qrcode_id
  let link='http://ap.bjcreate.net/school/'
  let openid
  let start_time
  let end_time
    export default {
        name: "detail",
        data(){
          return {
            lists:[

            ],
          }
        },
      mounted() {
        role=this.$route.query.role
        qrcode_id=this.$route.query.qrcode_id
        openid=this.$route.query.openid
        start_time=this.$route.query.start_time
        end_time=this.$route.query.end_time
        this.getenlsitdetail()
      },
      created() {

      },
      methods:{
        getenlsitdetail(){
          this.$axios.post(link+'api/school/getadminambassadorregdetails',
            {
              openid:openid,
              qrcode_id:qrcode_id,
              start_time:start_time,
              end_time:end_time
            }
          ).then(res=>{
            console.log(res.data)
            if(res.data.ResultData&&res.data.ResultData.length>0){
              res.data.ResultData.forEach(value=>{
                value.create_time=value.create_time.split('T')[0]
              })
            }
            this.lists=res.data.ResultData


          }).catch(error=>{
            console.log(error)
          })
        },
        link(e){
          console.log(e)
          if(e==1){
            this.$router.push({
              path:'/?o='+openid+'&r='+role
            })
          }else if(e==2){
            this.$router.push({
              path:'search?openid='+openid+'&role='+role
            })
          }
        },
      }
    }
</script>

<style scoped>
  .detail{
    padding-bottom:1.6rem;
  }
   /*表格*/
  .flex-box{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size:0.24rem;
    line-height:0.72rem;
    border-bottom:1px solid #eaeaea;
    color:#555555;
    padding:0 0.3rem;
  }
  .flex-box.special{
    color:#000;
  }
  .first{
    width:1rem;
  }
  .second{
    width:1.6rem;
    line-height: 0.4rem;
  }
  .third{
    width:2.5rem;
  }
  .fourth{
    width:1.6rem;
  }

  .box{
    padding-top:0.3rem;
    margin:0 auto;
    background-color:#fff;
  }
  .list{
    padding: 0.2rem 0.26rem;
    font-size:0.3rem;
    background-color:#fff;
    margin:0.2rem auto 0;
    border-radius:5px;
    max-width: 6.8rem;
  }
  .options{
    line-height:0.7rem;
    padding-left:0.2rem ;
  }
  .head{
    width:100%;
    height:1rem;
    background-image: linear-gradient(#FEA827, #FF8636);
    overflow: hidden;
  }
  .title{
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height:0.8rem;
    font-size:0.32rem;
    padding:0 0.26rem;
    background-color: #fff;
    border-radius:9px;
    max-width:6.8rem;
    margin:0 auto 0;
  }
  .title.special{
    margin:-0.3rem auto 0;
    padding:0.2rem 0.26rem;
  }
  .search{
    width:1.44rem;
    height:0.56rem;
    line-height:0.56rem;
    text-align:center;
    color:#fff;
    font-size:0.22rem;
    background-color:#FF961E;
    border-radius:25px;
  }
  .group{
    width:5rem;
    height:0.56rem;
    line-height:0.56rem;
    border:1px solid #D9D9D9;
    border-radius:3px;
  }
  .txt{
    display: inline-block;
    vertical-align: middle;
  }
  .icon{
    display: inline-block;
    width:0.34rem;
    height:0.3rem;
    background: url(../assets/icon12.png) no-repeat center top;
    background-size: 100%;
    margin-right:0.2rem;
    vertical-align: middle;
  }
  .icon6{
    display: inline-block;
    width:0.26rem;
    height:0.26rem;
    background: url(../assets/icon13.png) no-repeat center top;
    background-size: 100%;
    margin-right:0.2rem;
    margin-left:0.3rem;
    vertical-align: middle;
  }
  .group input{
    border:none;
    outline:none;
    height:0.56rem;
    line-height:0.56rem;
    vertical-align: middle;
    background-color:transparent;
  }

  .foot{
    position: fixed;
    width:100%;
    height:1.3rem;
    background-color:#fff;
    left:0;
    bottom:0;
    font-size:0.22rem;
    display: flex;
    align-items:flex-start;
    justify-content: space-between;
    padding-top:0.2rem;
    color:#A8A8A8;
    box-shadow:2px 0px 5px rgba(0,0,0,0.2);
  }
  .foot.special{
    justify-content: center;
  }
  .foot>.tabs{
    width:2.3rem;
    text-align: center;
  }
  .foot.special>.tabs{
    width:3.3rem;
    text-align: center;
  }
  .tab1{
    width:0.4rem;
    height:0.4rem;
    background: url(../assets/icon9.png) no-repeat center top;
    background-size: 100%;
    margin:0 auto 0.1rem;
  }
  .tabs.on .tab1{
    background: url(../assets/icon9-on.png) no-repeat center top;
    background-size: 100%;
  }
  .foot>.on .txt{
    color:#FF9831;
  }

  .tab2{
    width:0.4rem;
    height:0.4rem;
    background: url(../assets/icon10.png) no-repeat center top;
    background-size: 100%;
    margin:0 auto 0.1rem;
  }
  .tabs.on .tab2 {
    background: url(../assets/icon10-on.png) no-repeat center top;
    background-size: 100%;
  }
  .tab3{
    width:0.4rem;
    height:0.4rem;
    background: url(../assets/icon16.jpg) no-repeat center top;
    background-size: 100%;
    margin:0 auto 0.1rem;
  }
  .tabs.on .tab3{
    background: url(../assets/icon16-on.jpg) no-repeat center top;
    background-size: 100%;
  }
  a{
    text-decoration:none;
    outline: none;	/* 去除旧版浏览器的点击后的外虚线框 */
    color: #000;
  }
  .txt{
    color:#000;
  }

</style>



// WEBPACK FOOTER //
// src/components/detail.vue